<template>
  <div v-if="isDataLoaded">
    <v-dialog
      v-model="dialog"
      transition="dialog-bottom-transition"
      persistent
      max-width="1200"
    >
      <!--begin::Modal dialog-->
      <div class="bg-white poppins">
        <!--begin::Modal header-->
        <div class="modal-header py-4 align-center">
          <h4 class="mb-0 font-weight-bolder">Services</h4>
          <!--begin::Close-->
          <div
            class="btn btn-sm btn-icon btn-active-light-info"
            @click="toggleModal"
          >
            <span class="svg-icon">
              <v-icon size="22">mdi-close</v-icon>
            </span>
          </div>
          <!--end::Close-->
        </div>
        <!--begin::Modal header-->
        <!--begin::Modal body-->
        <div class="modal-body d-flex flex-column scroll-y mx-5 py-7">
          <!--begin::Body-->

          <div class="row">
            <div class="col-12">
              <ActionBuilder
                :query="formData.configurations"
                :options="serverData.types"
                :operators="serverData"
                ref="actionBuilder"
              />
            </div>
          </div>

          <!--end::Body-->

          <!--begin::Actions-->
          <div class="my-4 d-flex flex-grow-1 align-end justify-center">
            <button
              type="reset"
              class="btn btn-light mr-3 px-5 py-3 ls1"
              @click="resetEditForm"
            >
              Reset
            </button>
            <button
              type="submit"
              class="btn btn-info px-5 py-3 ls1"
              @click="submitEditForm"
            >
              Submit
            </button>
          </div>
          <!--end::Actions-->
        </div>
        <!--end::Modal body-->
      </div>
      <!--end::Modal dialog-->
    </v-dialog>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import ActionBuilder from "@/own/components/customers/clients/actionBuilder/ActionBuilder";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import ApiService from "@/core/services/api.service";

export default {
  name: "Services",
  components: { ActionBuilder },
  props: [],
  data: () => ({
    dialog: false,
    serverData: null,
    formData: {
      configurations: null,
    },
  }),
  methods: {
    loadDataFromServer() {
      this.pageLoader(true);
      let data = {
        customer_id: { ...this.$store.getters.getItemForAction }.id,
      };
      ApiService.post("/customer_service/customer_configuration/edit", data)
        .then((response) => {
          this.serverData = response.data;
          this.formData.configurations = response.data.configurations;
          this.pageLoader(false);
        })
        .catch(() => {
          this.pageLoader(false);
        });
    },
    areServicesUniqueInConfigurations(configurations) {
      const ids = configurations.map((conf) => conf.type_id);
      const set = new Set(ids);
      return ids.length === set.size;
    },
    submitEditForm() {
      if (this.areServicesInValid) {
        // console.log('service not valid', this.$store.getters.getCLIENTNotValid);
        return;
      }
      if (
        !this.areServicesUniqueInConfigurations(this.formData.configurations)
      ) {
        Swal.fire({
          title: "Warning",
          text: `Duplicate service type detected!`,
          icon: "warning",
          showConfirmButton: false,
          timer: 2500,
        });
        return;
      }
      this.pageLoader(true);
      let data = {
        customer_id: { ...this.$store.getters.getItemForAction }.id,
        ...this.formData,
      };
      ApiService.post("/customer_service/customer_configuration/update", data)
        .then(() => {
          Swal.fire({
            title: "Updated",
            text: `Service data has been updated.`,
            icon: "success",
            showConfirmButton: false,
            timer: 2500,
          });
          this.toggleModal();
          this.resetEditForm();
          this.pageLoader(false);
        })
        .catch(() => {
          this.pageLoader(false);
        });
    },
    /**
     * reset data to intial value
     */
    resetEditForm() {
      this.formData = {
        configurations: [],
      };
    },
    toggleModal() {
      if (this.dialog) {
        this.dialog = !this.dialog;
        this.resetEditForm();
        this.serverData = null;
      } else {
        this.loadDataFromServer();
        this.dialog = !this.dialog;
      }
    },
    pageLoader(state) {
      this.$store.commit(SET_PAGE_LOADING, state);
    },
  },
  computed: {
    isDataLoaded: function () {
      return !!this.serverData;
    },
    areServicesInValid() {
      return this.$store.getters.getCLIENTNotValid;
    },
  },
};
</script>
